/**
 * <kj-copy-code> — copies the text of its [data-copy-source] element to the clipboard.
 * A button targets it with commandfor="<id>" command="--copy"; [data-copy-label] swaps to the copied message briefly.
 */
class KjCopyCode extends HTMLElement {
  #timer = null;
  #onCommand = (event) => {
    if (event.command === '--copy') this.#copy();
  };

  connectedCallback() {
    this.addEventListener('command', this.#onCommand);
  }

  disconnectedCallback() {
    this.removeEventListener('command', this.#onCommand);
    window.clearTimeout(this.#timer);
  }

  async #copy() {
    const source = this.querySelector('[data-copy-source]');
    const label = this.querySelector('[data-copy-label]');
    const status = this.querySelector('[data-copy-status]');
    const code = (source?.textContent || '').trim();
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
    } catch {
      const range = document.createRange();
      range.selectNodeContents(source);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
      selection.removeAllRanges();
    }
    const copied = this.dataset.copiedText || '';
    if (label) {
      label.dataset.original ??= label.textContent;
      label.textContent = copied;
    }
    if (status) status.textContent = copied;
    this.toggleAttribute('data-copied', true);
    window.clearTimeout(this.#timer);
    this.#timer = window.setTimeout(() => {
      if (label) label.textContent = label.dataset.original;
      if (status) status.textContent = '';
      this.toggleAttribute('data-copied', false);
    }, 2000);
  }
}

if (!customElements.get('kj-copy-code')) customElements.define('kj-copy-code', KjCopyCode);
